<template>
  <transition name="fade">
    <div class="tooltip" v-if="options.content"
         :style="options.styles"
         v-html="options.content"></div>
  </transition>
</template>

<script>
  export default {
    name: 'Tooltip',

    props: ['options']
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/styles/mixins";
  @import "../../assets/styles/animations";

  .tooltip {
    background-color: rgba(68, 68, 68, 0.75);
    color: #e7e7e7;
    @include border-radius(4px);
    position: absolute;
    padding: 10px;
    @include box-shadow(0 0 10px rgba(0, 0, 0, 0.5));
    transform: translate(-50%, 0);
  }
</style>
